import { FC, ReactNode } from 'react'
import { Box, SxProps, Theme } from '@mui/material'

type TabPanelProps = {
  children?: ReactNode
  index: number | string
  value: number | string
  isAlwaysRendered?: boolean
  hidden?: boolean
  sx?: SxProps<Theme>
  contentSx?: SxProps<Theme>
}

export const TabPanel: FC<TabPanelProps> = ({
  children,
  value,
  index,
  contentSx,
  isAlwaysRendered = false,
  ...other
}) => {
  return (
    <Box hidden={value !== index} role='tabpanel' {...other}>
      {(value === index || isAlwaysRendered) && <Box sx={{ p: 1, ...contentSx }}>{children}</Box>}
    </Box>
  )
}
